import React, {
  useRef, useEffect, useState,

} from 'react';
import {
  Swiper, SwiperSlide, useSwiper,
} from 'swiper/react';
import 'swiper/css';
import { debounce } from 'lodash';
import Page from 'modules/app/components/Page';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as IconArrowLeft } from 'images/icons/arrow-left.svg';
import useUserPosts from 'sdk/hooks/user/useUserPosts';
import styles from './Feed.module.scss';
import NoContentFound from '../Feed/NoContentFound';
import Wheel from '../Feed/Wheel';
import PostBlock from '../Feed/PostBlock';

function FeedById() {
  const feedRef = useRef(null)
  const [feed] = useState<any>({})
  const [feedGroup, setFeedGroup] = useState<any>('global')
  const prevDeltaY = useRef(0);
  const prev2DeltaY = useRef(0);
  const prev3DeltaY = useRef(0);
  const wheelEventTimeLast = useRef(new Date().getTime());
  const wheelEventTimeLastForTouchPad = useRef(new Date().getTime());
  const [videoMuted, setVideoMuted] = useState<boolean>(false);
  const [wheelStatus, setWheelStatus] = useState<string | null>(null);
  const [, setCurrentSlide] = useState<number>(0);
  const navigate = useNavigate()
  const onSlideChange = () => { // @ts-ignore
    // const lastPost = feedRef.current.swiper.activeIndex
    // @ts-ignore
    // const activeId = document.querySelectorAll('.swiper-slide')[(lastPost || 0)]?.dataset?.id
    // navigate(`/user/feed/${feedName}/${feedId}/${activeId}`)
  }

  const swiper = useSwiper();
  const { state } = useLocation()

  useEffect(() => {
    if (state.active && feedRef.current) { // @ts-ignore
      feedRef.current?.swiper.slideTo(state.active, 0)
    }
  }, [swiper?.slideTo, feedRef.current])

  const { data: rawPosts, isLoading } = useUserPosts(state.ids)

  const posts: any = []
  state.ids.filter((id) => {
    const post = rawPosts?.find((r) => r.id === id)

    if (post) {
      posts.push({
        data: post,
        hasNextPage: '',
        slideTo: '',
        ...post?.feed_data?.['global_flat:global'],
      })
    }
    return post
  })

  const debouncedOnWheel = debounce((status) => {
    setWheelStatus(status);
    setTimeout(() => {
      setWheelStatus(null);
    }, 300)
  }, 310, {
    leading: true,
    trailing: false,
  })

  const OnWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    const { deltaY } = event;

    const currentTime = new Date().getTime();

    if (currentTime - wheelEventTimeLast.current > 500) {
      if (deltaY > 0) {
        debouncedOnWheel('up');
      } else {
        debouncedOnWheel('down');
      }
      wheelEventTimeLastForTouchPad.current = new Date().getTime();
    } else if (currentTime - wheelEventTimeLastForTouchPad.current > 500) {
      if (
        (deltaY > 0 && deltaY > prevDeltaY.current
        && prevDeltaY.current > prev2DeltaY.current && prev2DeltaY.current > prev3DeltaY.current)
    || (deltaY < 0 && deltaY < prevDeltaY.current
        && prevDeltaY.current < prev2DeltaY.current && prev2DeltaY.current < prev3DeltaY.current)
      ) {
        debouncedOnWheel(deltaY > 0 ? 'up' : 'down');
      }
      prev3DeltaY.current = prev2DeltaY.current;
      prev2DeltaY.current = prevDeltaY.current;
      prevDeltaY.current = deltaY;
    }

    wheelEventTimeLast.current = currentTime;
  }

  const handleKeyDownUp = (event) => {
    if (event.key === 'ArrowDown') {
      // @ts-ignore
      feedRef.current?.swiper?.slideNext();
    } else if (event.key === 'ArrowUp') {
      // @ts-ignore
      feedRef.current?.swiper?.slidePrev();
    }
  };

  useEffect(() => {
    if (posts.length) {
      document.addEventListener('keydown', handleKeyDownUp);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDownUp);
    };
  }, [posts]);

  const handleMuted = (value) => {
    setVideoMuted(value)
  }

  const handleSetCurrentSlide = (slide) => {
    setCurrentSlide(slide)
  }

  if (!posts || posts.length === 0 || isLoading) {
    return (
      <NoContentFound setFeedGroup={setFeedGroup} isLoading={isLoading} />
    )
  }

  return (
    <div
      className={styles.container}
      onWheel={(event) => {
        event.stopPropagation()
        OnWheel(event)
      }}
    >
      <Swiper
        className={styles.posts}
        ref={feedRef}
        direction="vertical"
        slidesPerView={1}
        centeredSlides
        speed={200} // Added speed for smooth scrolling
        effect="slide"
        spaceBetween={0}
        onSlideChange={onSlideChange}
        touchStartPreventDefault={false}
        breakpoints={{
          501: {
            slidesPerView: 'auto',
            spaceBetween: 10,
            autoHeight: true,
          },
          1401: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            autoHeight: true,
          },
        }}
      >
        <Wheel wheelStatus={wheelStatus} />
        {posts?.length ? (posts.map((post: any, idx: number) => (
          <SwiperSlide key={post?.data?.id} className={styles.postContainer} data-id={post?.data?.id}>
            {({ isActive, isNext, isPrev }) => (
              isActive || isNext || isPrev ? (
                <PostBlock
                  data={post}
                  feed={feed}
                  setCategoryFilter={setFeedGroup}
                  category={feedGroup}
                  videoMuted={videoMuted}
                  onVideoMuted={handleMuted}
                  onSetCurrentSlide={handleSetCurrentSlide}
                  idx={idx}
                  isActive={isActive}
                />
              ) : (
                <div className={styles.panel} />
              )
            )}
          </SwiperSlide>
        ))) : null }
      </Swiper>
    </div>
  )
}

function FeedByIdPage() {
  useEffect(() => {
    document.body.classList.add('overflow-hidden');

    return () => {
      document.body.classList.remove('overflow-hidden');
    }
  })

  return (
    <Page activeLink="/user/feed">
      <FeedById />
    </Page>
  )
}

export default FeedByIdPage
